var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "staff-member-item",
      attrs: { "data-testid": "about_staff_member_item" }
    },
    [
      _c("img", {
        staticClass: "staff-avatar",
        attrs: {
          "data-testid": "about_staff_member_avatar",
          src: _vm.staffMember.avatar,
          alt: _vm.staffMember.name
        }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "staff-member-name",
          attrs: { "data-testid": "about_staff_member_name" }
        },
        [_vm._v(_vm._s(_vm.staffMember.name))]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "staff-member-title",
          attrs: { "data-testid": "about_staff_member_title" }
        },
        [_vm._v(_vm._s(_vm.staffMember.title))]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }